module.exports = __webpack_public_path__ + "img/c05_unittechprimuspiluschampion_Normal_ua.7654aef6.webp";